export class ErzeugungsanlageImportJob {
    public report?: string;
    public erzeugerTotal: number;
    public nrProcessedTransformations: number;
    public nrStoredErzeuger: number;
    public phase: ErzeugungsanlageImportJobPhase;
    public error?: boolean;
    public done?: boolean;
}

export enum ErzeugungsanlageImportJobPhase {
    PHASE_INITIAL = 10,
    PHASE_VALIDATE = 20,
    PHASE_CHECK_CONSTRAINT = 30,
    PHASE_CHECK_PLANWERTE = 35,
    PHASE_PERSIST = 40,
    PHASE_FINALIZE = 50
}

export const initialImportJob: ErzeugungsanlageImportJob = {
    erzeugerTotal: 0,
    nrProcessedTransformations: 0,
    nrStoredErzeuger: 0,
    phase: ErzeugungsanlageImportJobPhase.PHASE_INITIAL,
};
